import { motion } from "framer-motion";
import AnimatedCounter from "./AnimatedCounter";

export const TradeDistribution = ({ data }) => {
  if (!data?.bars?.length) {
    return (
      <motion.div
        className="panel lg:col-span-4 flex flex-col min-h-[240px] p-4"
        data-testid="trade-distribution-panel"
      >
        <span className="label-uppercase">Decision Distribution</span>
        <p className="mt-2 text-sm text-text-secondary font-mono">No decision_log data.</p>
      </motion.div>
    );
  }
  const max = Math.max(...data.bars.map((b) => b.value), 1);
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.25 }}
      className="panel lg:col-span-4 flex flex-col min-h-[240px]"
      data-testid="trade-distribution-panel"
    >
      <div className="panel-header">
        <h3 className="font-display text-sm font-bold uppercase tracking-tight">
          Decision Distribution
        </h3>
        <span className="label-micro">decision_log</span>
      </div>

      <div className="grid grid-cols-3 border-b border-border">
        <Stat label="Win Rate" value={data.winRate} suffix="%" tone="positive" />
        <Stat label="Avg Return" value={data.avgReturn} suffix="R" />
        <Stat label="Risk / Reward" value={data.rr} suffix=":1" tone="magenta" />
      </div>

      <div className="flex-1 p-3 flex flex-col gap-2.5">
        {data.bars.map((b, idx) => {
          const w = (b.value / max) * 100;
          const positive = b.label === "WIN" || b.label === "MAX TARGET";
          return (
            <div key={b.label} className="flex items-center gap-3 text-[11px] font-mono">
              <span className="w-24 text-text-secondary uppercase tracking-[0.12em]">
                {b.label}
              </span>
              <div className="flex-1 h-3 bg-surface-muted relative" style={{ borderRadius: 1 }}>
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${w}%` }}
                  transition={{ duration: 0.9, delay: idx * 0.08, ease: "easeOut" }}
                  className={`h-full ${positive ? "bg-positive" : "bg-magenta"}`}
                  style={{ borderRadius: 1 }}
                />
              </div>
              <span className="w-10 text-right num text-foreground">{b.value}</span>
              <span className="w-12 text-right num text-text-secondary">{b.pct}%</span>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

const Stat = ({ label, value, suffix, tone = "default" }) => {
  const tc = tone === "magenta" ? "text-magenta" : tone === "positive" ? "text-positive" : "text-foreground";
  return (
    <div className="p-3 border-r last:border-r-0 border-border">
      <div className="label-micro">{label}</div>
      <div className={`text-lg font-mono num ${tc}`}>
        <AnimatedCounter value={value} decimals={value % 1 ? 2 : 1} suffix={suffix} duration={1100} />
      </div>
    </div>
  );
};

export default TradeDistribution;
